import { getLuminance } from 'polished';
export var readableTextColor = function readableTextColor(color) {
  return getLuminance(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};